// frontend/src/pages/Home/Home.tsx
import React, { useEffect, useState } from "react";
import SeriesCarousel from "../../components/SeriesCarousel";
import HeroCarousel from "../../components/HeroCarousel/HeroCarousel";
import { Homeslides } from "../../data/sliedsData";
import FeaturedSeriesShowcase from "../../components/home-components/FeaturedSeriesShowcase";
import BrandPromise from "../../components/home-components/BrandPromise";
import CommercialSolutions from "../../components/home-components/CommercialSolutions";
import BrandExcellence from "../../components/home-components/BrandExcellence";
import FurnitureSelectionGuide from "../../components/home-components/FurnitureSelectionGuide";
import MostPopularProducts from "../../components/home-components/MostPopularProducts";
import CustomerFavorites from "../../components/home-components/CustomerFavorites";
import styles from "./home.module.css";
import { getAllSeries } from "../../service/galleryService";
import { Helmet } from "react-helmet-async";
import HomeDiscountSection from "../../components/home-discount-section";
import OfficeTourReel from "../../components/OfficeTourReel";

const Home = () => {
  const [seriesData, setSeriesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchSeries = async () => {
    try {
      setLoading(true);
      const data = await getAllSeries();
      setSeriesData(() => data);
    } catch (err: any) {
      setError(err.message || "Failed to load furniture series");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSeries();
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FurnitureStore",
            name: "Scadel Furniture",
            description:
              "Premium commercial and office furniture manufacturer in India specializing in office chairs, workstations, school furniture, and custom furniture solutions.",
            url: "https://www.scadelfurniture.in",
          }),
        }}
      />
      <Helmet>
        <title>Scadel Furniture</title>
        <meta
          name="description"
          content="Scadel Furniture - Premium office chairs, commercial furniture, school desks, and custom furniture solutions across India. Best quality with modern designs."
        />
        <meta
          name="keywords"
          content="Scadel Furniture, office furniture, commercial furniture, school furniture, office chairs, Scadel India, furniture manufacturer"
        />
        <link rel="canonical" href="https://www.scadelfurniture.in/" />

        <meta property="og:title" content="Scadel Furniture" />
        <meta
          property="og:description"
          content="India's leading manufacturer of premium commercial furniture, office chairs, and custom furniture solutions."
        />
        <meta property="og:url" content="https://www.scadelfurniture.in/" />
      </Helmet>
      <div className={styles.homeContainer}>
        {/* Hero Section */}
        <HeroCarousel slides={Homeslides} />
        {/* All Series Showcase */}
        <SeriesCarousel initailData={seriesData} />
        {/* Features Discount Section */}
        <HomeDiscountSection />
        {/* Popular Products */}
        <MostPopularProducts initailData={seriesData} />
        {/* Featured Collections */}
        <FeaturedSeriesShowcase initailData={seriesData} />
        {/* Customer Favorites */}
        <CustomerFavorites />
        {/* Office Tour Reel Section */}
        <OfficeTourReel />
        {/* Selection Guide */}
        <FurnitureSelectionGuide />
        {/* Brand Excellence */}
        <BrandExcellence />
        {/* Industry Solutions */}
        <CommercialSolutions />
        {/* Brand Promise */}
        <BrandPromise />
      </div>
    </>
  );
};

export default Home;
